import { TCommentProps } from '../CommentsList';

export const sortComments = (comments: TCommentProps[]): TCommentProps[] =>
  comments.sort((a, b) => {
    const likesOrder = Number(b.likesCount) - Number(a.likesCount);
    const createdAtOrder = new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();

    return likesOrder === 0 ? createdAtOrder : likesOrder;
  });
